import { render, staticRenderFns } from "./PrescriptionItemSpecialRXTile.vue?vue&type=template&id=3311b2c4&scoped=true"
import script from "./PrescriptionItemSpecialRXTile.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItemSpecialRXTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3311b2c4",
  null
  
)

export default component.exports